import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.reseller.list', {
        url: '/list',
        component: 'companyResellerList',
        resolve: {
            companies
        },
    });

}

/** @ngInject */
function companies(ResellerCompanyResource,companyId){
    return ResellerCompanyResource.getCompanies(companyId)
}



// WEBPACK FOOTER //
// ./src/portal/states/company/reseller/list/reseller-list.state.js